import React, {useState, useEffect} from "react";
import FormModal from "./modifyModal";
import { callAPI } from "../../utils";
const generateYears = ({ start = 1900 } = {}) => {
  const years = [];
  const currentYear = new Date().getFullYear();
  for (let i = currentYear; i >= start; i--) {
    years.push({ value: i, label: i.toString() });
  }
  return years;
};

const filterFeedbackTags = (tags, attribute) => {
  return tags ? tags.filter(tag => tag.data.attribute === attribute) : [];
};

const mapTutorDataToFormData = (tutorData) => {
  const transformToArray = (data) => {
    if (Array.isArray(data)) {
      return data
        .filter(item => item.value !== null)
        .map(item => item|| null);
    }
    
    if (data && data.value !== null) {
      return [data || null];
    }
    
    return [];
  };

  return {
    baseData: {
      name: { value: tutorData.name?.value || null },
      email: { value: tutorData.email?.value || null },
      phoneNumber: { value: tutorData.phoneNumber?.value || null },
      address: { value: tutorData.address?.value || null },
      gender: { value: tutorData.gender[0]?.value || null },
      dateOfBirth: { value: tutorData.dateOfBirth?.value || null },
      bio: { value: tutorData.bio?.value || null },
      learningDifficultiesParagraph: { value: tutorData.learningDifficultiesParagraph?.value || null },
      howDidYouHearAboutUs: { value: tutorData.howDidYouHearAboutUs[0]?.value || null },
      level: { value: tutorData.level?.value || 1 },
      capacity: { value: tutorData.capacity?.value || 1 },
      carAccessibility: { value: tutorData.carAcessability?.value || 1 },
      licenseTimeline: { value: tutorData.licenseTimeline?.value || 1 },
      websiteProfile: { value: tutorData.websiteProfile?.value || 1 },
      referer: { value: tutorData.referer?.value || 1 },
      methodOfDelivery: { value: tutorData.methodOfDelivery[0]?.value || null },
      notes: { value: tutorData.notes?.value || null },
      parentFeedback: { value: tutorData.parentFeedback?.value || null },
      travelWillingness: { value: tutorData.travelWillingness[0]?.value || null },
      program: { value: tutorData.program?.value || 1 },
    },
    junctionData: {
      subjects: transformToArray(tutorData.subjects),
      experiences: transformToArray(tutorData.experience),
      learningDifficulties: transformToArray(tutorData.learningdifficulty),
      otherRoles: transformToArray(tutorData.otherRoles),
      englishNovels: transformToArray(tutorData.englishNovels),
      curriculums: transformToArray(tutorData.curriculums),
      positiveTags: transformToArray(tutorData.positiveTags),
      negativeTags: transformToArray(tutorData.negativeTags),
    },
    schoolingData: {
      graduationYear: { value: tutorData.graduationYear?.value || null },
      highschool: { value: tutorData.highschool[0]?.value || null },
      highschoolSubjects: { value: tutorData.highschoolSubjects?.value || null },
      university: { value: tutorData.university[0]?.value || null },
      degreeName: { value: tutorData.degreeName?.value || null },
      degreeCommencement: { value: tutorData.degreeCommencement?.value || null },
      degreeConclusion: { value: tutorData.degreeConclusion?.value || null },
    },
    businessData: {
      ABN: { value: tutorData.ABN?.value || null },
      WWCC: { value: tutorData.WWCC?.value || null },
      bankName: { value: tutorData.bankName?.value || null },
      accountName: { value: tutorData.accountName?.value || null },
      BSB: { value: tutorData.BSB?.value || null },
      accountNumber: { value: tutorData.accountNumber?.value || null },
    },
    statusData: {
      status: { value: tutorData.status?.value || 1 },
      statusInfo: { value: tutorData.statusInfo?.value || null },
      statusCheckin: { value: tutorData.statusCheckin?.value || null },
    },
    locationData: {
      primaryAddress: { value: tutorData.primaryAddress?.value || null },
      secondaryAddress: { value: tutorData.secondaryAddress?.value || null },
    },
    other: {
      sendEmail: {value: false}
    }
  };
};

const ManageTutorModal = ({ data, callbacks, mode }) => {
  const [staticTables, setStaticTables] = useState([]);
  const [initialFormData, setInitialFormData] = useState([]);
  const [formValues, setFormValues] = useState([]);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const getStaticTables = async () => {
      const response = await callAPI({
        request: "database/getStaticTables",
        method: "post",
        params: { tables: fieldsConfig.staticTables || [] },
        onSuccess: (response) => {
          setStaticTables(response.data);
        },
        onError: (errorMessage) => {
          console.error("Failed to fetch static tables:", errorMessage);
        },
      });

      return response.data
    };

    const getUsers = async () => {
      const response = await callAPI({
        request: "getUsers",
        method: "get",
        onSuccess: (response) => {
          let userArray = [{ label: "None", value: null}];

          response.data.forEach(entry => {
              userArray.push({ label: entry.name, value: entry.userId });
          });
          
          setUsers(userArray);
        },
        onError: (errorMessage) => {
          console.error("Failed to fetch users:", errorMessage);
        },
      });
    };

    const getTutor = async () => {
      if (mode === "create") return

      const response = await callAPI({
        request: "database/admin/getEntities",
        method: "post",
        params: { entityType: "tutors", entityID: data.id},
      });
  
      const tutor = mapTutorDataToFormData(response.data.data[0]);
      setFormValues(tutor)
      setInitialFormData(tutor)
    }

    getTutor()
    getUsers()
    getStaticTables()
  }, [data?.id, mode]);
 

  const fieldsConfig = {
    mapData: mapTutorDataToFormData,
    staticTables: [
      'gender', 'hdyhau', 'tutorlevels', 'capacitytags', 'caracessability', 'licencetimeline', 'websiteprofile', 'feedbacktags',
      'subjects', 'experiences/atributes', 'learningdifficulty', 'otherroletags', 'englishnovels', 'curriculums', 'highschools', 'universities', 'statuses', 'program', 'travelwillingness', 'methodofdelivery'
    ],
    sections: [
      {
        section: "Personal Information",
        fields: [
          { label: "Name", id: "baseData.name", type: "text", required: true },
          { label: "Gender", id: "baseData.gender", type: "select", required: true, options: staticTables?.gender || [] },
          { label: "Email", id: "baseData.email", type: "email", required: true },
          { label: "Phone Number", id: "baseData.phoneNumber", type: "tel", required: true },
          { label: "Address", id: "baseData.address", type: "text", required: true  },
          { label: "Date of Birth", id: "baseData.dateOfBirth", type: "date" },
          { label: "Bio", id: "baseData.bio", type: "textarea" },
          { label: "How Did You Hear About Us", id: "baseData.howDidYouHearAboutUs", type: "select", options: staticTables?.howdidyouhearaboutus || [] },
          { label: "Referer", id: "baseData.referer", type: "select", options: users },
        ]
      },
      {
        section: "Admin Information",
        fields: [
          { label: "Level", id: "baseData.level", type: "select", required: true, options: staticTables?.level || [], default: 1 },
          { label: "Capacity", id: "baseData.capacity", type: "select", options: staticTables?.capacity || [], required: true  },
          { label: "Program", id: "baseData.program", type: "select", options: staticTables?.program || [], required: true, default: 1  },
          { label: "Website Profile", id: "baseData.websiteProfile", type: "select", options: staticTables?.websiteprofile || [] },
    
          { label: "Primary Tutoring Address", id: "locationData.primaryAddress", type: "text", required: true  },
          { label: "Secondary Tutoring Address", id: "locationData.secondaryAddress", type: "text" },
    
          { label: "Car Accessibility", id: "baseData.carAccessibility", type: "select", options: staticTables?.caracessability || [] },
          { label: "License Timeline", id: "baseData.licenseTimeline", type: "select", options: staticTables?.licensetimeline || [] },
          { label: "Travel Willingness", id: "baseData.travelWillingness", type: "select", options: staticTables?.travelwillingness || [] },
    
          { label: "Positive Tags", id: "junctionData.positiveTags", type: "multi-select", options: filterFeedbackTags(staticTables?.feedbacktags || [], "positive")},
          { label: "Negative Tags", id: "junctionData.negativeTags", type: "multi-select", options: filterFeedbackTags(staticTables?.feedbacktags || [], "negative")},
    
          { label: "Notes", id: "baseData.notes", type: "textarea" },
        ]
      },
      { section: "Tutoring Information",
        fields: [
          { label: "Subjects", id: "junctionData.subjects", type: "multi-select", options: staticTables?.subjects || [], required: true },
          { label: "Curriculums", id: "junctionData.curriculums", type: "multi-select", options: staticTables?.curriculums || [] },
    
    
          { label: "Method of Delivery", id: "baseData.methodOfDelivery", type: "select", options: staticTables?.methodofdelivery || [], required: true },
          { label: "English Novels", id: "junctionData.englishNovels", type: "multi-select", options: staticTables?.englishnovels || []},
          { label: "History Revolutions", id: "baseData.historyRevolutions", type: "textarea" },
    
    
          { label: "Parent Feedback", id: "baseData.parentFeedback", type: "textarea" },
        ]
      },
      {
        section: "Educational Background",
        fields: [
          { label: "Highschool", id: "schoolingData.highschool", type: "select", options: staticTables?.highschool || [] },
          { label: "Graduation Year", id: "schoolingData.graduationYear", type: "select", options: generateYears() },
          { label: "Highschool Subjects", id: "schoolingData.highschoolSubjects", type: "textarea" },
    
          { label: "University", id: "schoolingData.university", type: "select", options: staticTables?.university || [] },
          { label: "Degree Name", id: "schoolingData.degreeName", type: "text" },
          { label: "Degree Commencement", id: "schoolingData.degreeCommencement", type: "select", options: generateYears() },
          { label: "Degree Conclusion", id: "schoolingData.degreeConclusion", type: "select", options: generateYears() }, 
        ]
      },
      {
        section: "Business Information",
        fields: [
          { label: "ABN", id: "businessData.ABN", type: "text", required: true  },
          { label: "WWCC", id: "businessData.WWCC", type: "text", required: true  },
    
          { label: "Bank Name", id: "businessData.bankName", type: "text", required: true  },
          { label: "Account Name", id: "businessData.accountName", type: "text", required: true  },
          { label: "BSB", id: "businessData.BSB", type: "text", required: true  },
          { label: "Account Number", id: "businessData.accountNumber", type: "text", required: true  },
        ]
      },
      {
        section: "Status Information",
        fields: [
          { label: "Status", id: "statusData.status", type: "select", options: staticTables?.status || [], required: true },
          { label: "Status Information", id: "statusData.statusInfo", type: "textarea" },
          { label: "Status Check-in Date", id: "statusData.statusCheckin", type: "date" },
        ]
      },
      {
        section: "Additional Information",
        fields: [
    
          { label: "Experiences", id: "junctionData.experiences", type: "multi-select", options: staticTables?.experience || [] },
          { label: "Other Roles", id: "junctionData.otherRoles", type: "multi-select", options: staticTables?.otherroles || [] },
    
          { label: "Learning Difficulties", id: "junctionData.learningDifficulties", type: "multi-select", options: staticTables?.learningdifficulty || [] },
          { label: "Learning Difficulties Paragraph", id: "baseData.learningDifficultiesParagraph", type: "textarea" },
        ]
      },
      {
        section: "Manage Tutor",
        fields: [
          mode === "create" && {
            label: "Send tutor an email apon account creation", 
            id: "other.sendEmail", 
            type: "checkbox", 
            checked: false, 
          },
          mode === "editWithName" && {
            label: "Send Password Reset", 
            id: "manageTutor.sendPasswordReset", 
            type: "button", 
            onChange: async () => {
              await callAPI({
                request: 'forgotPassword',
                method: 'post',
                params: { email: formValues?.["baseData"]?.["email"]?.["value"] },
                onError: (error) => {
                  console.error('Forgot Password Error:', error);
                },
              });
            }
          },
          mode === "editWithName" && {
            label: "Remove 2FA", 
            id: "manageTutor.remove2FA", 
            type: "button", 
            onChange: () => console.log("2fa reset")
          },
        ].filter(Boolean)
      },
    ],
    requiredFields: ["other.sendEmail"],
  };

  const submitAPI = "tutors/modifyTutor";
  const deleteAPI = `tutors/deleteTutor/${data.id}`;

  const onSubmitSuccess = (updatedData, mode) => {
    callbacks.updateRow(updatedData, "tutorId", mode === "editWithName" ? "modify" : "create");
    callbacks.onClose();
    if (data?.reloadOnSuccess) window.location.reload();
  };

  const onClose = () => {
    callbacks.onClose();
  };

  return (
    <FormModal
      fieldsConfig={fieldsConfig}
      data={data}
      mode={mode}
      changes = {"changedFields"}
      type={"sidePeak"}
      title={mode === "editWithName" ? "Editing tutor: " + formValues?.["baseData"]?.["name"]?.value : "Creating tutor"}
      submitAPI={submitAPI}
      deleteAPI={deleteAPI}
      onSubmitSuccess={onSubmitSuccess}
      onClose={onClose}
      formData={formValues}
      initialFormData = {initialFormData}
      setFormData={setFormValues}
    />
  );
};

export default ManageTutorModal;
